/**
 * PCA (Public Client Application) instance
 * Separated to avoid circular dependencies
 */

import { PublicClientApplication } from '@azure/msal-browser';
import { configuration } from './authConfig';

// Create a mutable object to hold the PCA instance
export const PCAHolder = {
  pca: new PublicClientApplication(configuration)
};

// Export a getter for backward compatibility
export const getPCA = () => PCAHolder.pca;

